module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/inner-1-5048eba6f0b7916c82b88fc76acc9035.jpg";